import { Button } from '@mantine/core';
import { IconMapOff } from '@tabler/icons-react';
import { Link } from 'react-router';
import { EmptyState } from '../components/ui';

export function NotFoundPage() {
  return (
    <EmptyState
      icon={<IconMapOff size={24} />}
      title="Nie ma takiej strony"
      hint="Adres jest niepoprawny albo moduł jeszcze nie powstał."
      action={
        <Button component={Link} to="/" mt="xs">
          Wróć na pulpit
        </Button>
      }
    />
  );
}
